import { Button, Skeleton, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useCurrentCampaignYear } from '/@/hooks/zones';
import { _ } from '/@/locale';
import { getNodeScopeFilters } from '/@/utils/node-scope';
import { reverse } from '/@/utils/router';
import FieldsRankingReportDashboardCard from '../../../growers/components/fields-ranking-report-dashboard-card';
import HybridRankingReportDashboardCard from '../../../growers/components/hybrids-ranking-report-dashboard-card';

const ReportsSection = ({ userNodeId }: { userNodeId?: number }) => {
    const currentCampaignYear = useCurrentCampaignYear();
    const year = currentCampaignYear !== null ? currentCampaignYear - 1 : new Date().getFullYear() - 1;
    const lastTwoDigitsYear = year.toString().slice(-2);
    const navigate = useNavigate();
    return (
        <Stack spacing={3}>
            <Stack spacing={1}>
                <Typography color='primary' variant='h5'>
                    {`${_('Reportes de campaña maíz')} ${lastTwoDigitsYear}/${Number(lastTwoDigitsYear) + 1}`}
                </Typography>
                <Typography color='primary.mui.inactive' variant='body2'>
                    {_('Resumen de tus lotes e híbridos con mejor rendimiento.')}
                </Typography>
            </Stack>
            <Stack spacing={2}>
                {userNodeId ? (
                    <>
                        <FieldsRankingReportDashboardCard
                            growerNodeId={userNodeId}
                            year={year}
                            crop='corn'
                            nodeScope={getNodeScopeFilters('myFields')}
                        />
                        <HybridRankingReportDashboardCard
                            growerNodeId={userNodeId}
                            year={year}
                            crop='corn'
                            nodeScope={getNodeScopeFilters('myFields')}
                        />
                    </>
                ) : (
                    <Skeleton variant='rectangular' height='500px' width='100%' />
                )}
            </Stack>
            <Button
                variant='contained'
                color='primary'
                onClick={() => navigate(reverse('reports.List'))}
                sx={{
                    width: 'fit-content',
                }}
            >
                {_('Ver Reportes de campañas')}
            </Button>
        </Stack>
    );
};

export default ReportsSection;
